// extracted by mini-css-extract-plugin
export default {"modalOverlay":"hD-z","modalContent":"iD-z","header":"jD-z","close":"kD-z"};